import {
  isPostPaymentAbstractEnabled,
  POST_PAYMENT_ABSTRACT_FORM_STEP,
} from "./registrationModules";

export const handlePaymentConfirmationResult = ({
  confirmResult,
  abstractStepNumber,
  setFormData,
  setStep,
  showAlert = window.alert,
}) => {
  if (!confirmResult.ok) {
    const errorText = confirmResult.errorText;
    showAlert(`Payment verified but confirming registration failed: ${errorText}`);
    return;
  }

  showAlert("Payment successful! Processing registration...");

  const processConfirmation = async () => {
    try {
      const confirmed = confirmResult.confirmed;

      setFormData((prev) => ({
        ...prev,
        paid: true,
        id: confirmed.registrationId,
        regId: confirmed.id,
      }));

      setTimeout(() => {
        showAlert("Registered successfully. Details Emailed");

        if (isPostPaymentAbstractEnabled(abstractStepNumber)) {
          console.log("📝 Abstract after payment - showing post-payment abstract form");
          setStep(POST_PAYMENT_ABSTRACT_FORM_STEP);
        } else {
          setStep(1);
        }
      }, 500);
    } catch (confirmError) {
      console.error("Background confirmation error:", confirmError);
      showAlert("Payment successful but confirmation pending. Check your email.");
    }
  };

  processConfirmation();
};
